<style lang="scss">
@import './chart-move.scss';
</style>
<template>
    <div class="app-chart">
      <!-- 切换展示图表状态的按钮 -->
      <div v-show="showTransform" class="app-chart-type">
        <span
          class="iconfont icon-curve tm-icon-font app-chart-type-icon"
          @click="changeChartType('chart')">
          <span class="path1" :class="[transformType ? 'path': 'nopath']"></span>
          <span class="path2" :class="[transformType ? 'path': 'nopath']"></span>
        </span>
        <span
          class="iconfont icon-form tm-icon-font app-chart-type-icon"
          :style="{ color: transformType? '#BDC5D5':'#5cadff'}"
          @click="changeChartType('table')"></span>
      </div>
      <!-- 图表 -->
      <div :class="[transformType ? 'chart-move':'hideChart']">
        <div class="chart-move-metrice">
          <slot name="chart-move-metrice"></slot>
        </div>
        <div class="chart-move-charts">
          <Spin v-if="spinShow" fix>
            <Icon
              v-show="lodingInfo === this.$t('common.loading')"
              type="ios-loading"
              size='18'
              class="demo-spin-icon-load"></Icon>
            <div>{{ lodingInfo }}</div>
          </Spin>
          <Spin v-else-if="errorSpin" fix>
            <Icon type="md-close" size="18" color="#ff5500"></Icon>
            <div style="color: #ff5500;">{{ $t('common.errorTip') }}</div>
          </Spin>
          <div class="chart-move-charts-c" ref='area'></div>
        </div>
      </div>
      <!-- 表格 -->
      <div v-if="showTransform" :class="[transformType ? 'hideChart':'table-move']">
        <Spin v-if="spinShow" fix>
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>{{ lodingInfo }}</div>
        </Spin>
        <Spin v-else-if="errorSpin" fix>
          <Icon type="md-close" size="18" color="#ff5500"></Icon>
          <div style="color: #ff5500;">{{ $t('common.errorTip') }}</div>
        </Spin>
        <table-move
          v-else
          :change-data="initTableData.data"
          :table-columns="initTableData.columns"
          :padding-bottom='10'
          @on-table-move-sort="sortTable"
          ref='tablemove'></table-move>
      </div>

    </div>
</template>
<script>
import echarts from 'echarts';
import tableMove from '../table-move/table-move';
import numberSeparator from '../../filters/number-separator';
import sortData from '../../filters/sort-table-data';

export default {
  name: 'chartMove',
  props: {
    showTransform: false,
    chartName: String,
    parentString: String,
  },
  data() {
    return {
      myChart: '',
      transformType: true, // 展示类型 图表/表格
      spinShow: true, // 图表加载状态显示/隐藏
      lodingInfo: this.$t('common.loading'), // 加载文字
      noData: true, // 表格加载状态显示/隐藏
      errorSpin: false, // 数据加载失败状态显示/隐藏
      initChartInfo: {
        legendName: [],
        xaxisData: [],
        yaxis: [],
        series: [],
      },
      initTableData: {
        columns: [],
        data: [],
      },
    };
  },
  computed: {},
  components: {
    tableMove,
  },
  filters: {
    numberSeparator,
    sortData,
  },
  mounted() {
    window.addEventListener('resize', this.myChartResize, false);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.myChartResize, false);
    if (this.myChart) {
      this.myChart.dispose();
    }
  },
  methods: {
    myChartResize() {
      if (this.myChart) {
        this.myChart.resize();
      }
    },
    resizeChart() {},
    /**
     * 初始化图表
     * @param  {[Array]} legendName [图例名称数组]
     * @param  {[Array]} xaxisData  [X轴维度数组]
     * @param  {[Array]} yaxis      [Y轴展示的数据]
     * @param  {[Array]} series     [图表series的数据]
     */
    initChart(legendName, xaxisData, yaxis, series, stack) {
      const self = this;
      self.initChartInfo = {
        legendName,
        xaxisData,
        yaxis,
        series,
      };
      // 需要转换单位为 ‘%’的名称数组
      const rateArr = [self.$t('transaction.dayPayRate.tabs'),
        self.$t('transaction.weekPayRate.tabs'),
        self.$t('transaction.monthPayRate.tabs'),
        self.$t('transaction.payOrder.payOrderRate')];
      const option = {
        color: ['#1495EB', '#00CC66', '#F9D249', '#ff9900', '#9860DF'],
        legend: {
          right: 5,
          top: 0,
          itemWidth: 16,
          itemHeight: 4,
          itemGap: 12,
          icon: 'roundRect',
          data: legendName,
          textStyle: {
            color: '#464c5b',
          },
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#FFF',
          borderColor: '#C3CBD6',
          borderWidth: 1,
          axisPointer: {
            lineStyle: {
              color: '#C3CBD6',
            },
          },
          padding: [0, 10],
          formatter: (a) => {
            let volumn = '';
            if (stack) {
              let count = 0;
              a.forEach(x => (count += x.value));//eslint-disable-line
              volumn = `<p class='formatter-content'>
                <span class="formatter-content-legend" style="background: #FFFFFF;"></span>
                <span>${self.$t(stack)}</span>
                <b>${count}</b>
              </p>`;
            }
            let formatterStr = `<h3 class="formatter-title">${a[0].name}</h3>${volumn}`;
            for (let i = 0; i < a.length; i += 1) {
              const keep = rateArr.indexOf(a[i].seriesName) > -1 ? '%' : '';
              formatterStr += `<p class='formatter-content'>
                <span class="formatter-content-legend" style="background: ${a[i].color};"></span>
                <span>${a[i].seriesName}</span>
                <b>
                  ${a[i].value === undefined ? '--' : numberSeparator(a[i].value)}${keep}
                </b>
              </p>`;
            }
            return formatterStr;
          },
        },
        grid: {
          left: 16,
          right: 25,
          bottom: 5,
          top: 60,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#D7DDE4',
              },
            },
            axisTick: {
              alignWithLabel: true,
              lineStyle: {
                color: '#D7DDE4',
              },
            },
            axisLabel: {
              textStyle: {
                color: '#7F8B9C',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#F5F7F9',
              },
            },
            data: xaxisData,
          },
        ],
        yAxis: yaxis,
        series,
      };
      if (self.$refs.area !== null) {
        self.myChart = echarts.init(self.$refs.area);
        self.myChart.setOption(option);
      }
    },
    /**
     * 初始化表格
     * @param  {[Array]} columns [表格表头数据]
     * @param  {[Array]} data [表格内容数据]
     */
    initTable(columns, data) {
      this.noData = false;
      this.initTableData.columns = columns;
      this.initTableData.data = data;
    },
    /**
     * 切换图表类型
     */
    changeChartType(type) {
      this.$emit('on-change-chart-type', type, this.parentString);
    },
    /**
     * 下载表格数据
     */
    exportTable(name) {
      this.$refs.tablemove.exportTable(name);
    },
    /** 自定义排序
    * @param  {[Object]} obj [点击排序列内容]
    * @param {String} name [table-move 绑定的refs 表格数据前缀 例：ref为pageTable，则此表格绑定数据为pageTableData]
    */
    sortTable(obj, tableData) {
      const data = tableData;
      const list = sortData(obj, data);
      this.initTableData.data = list;
    },
    clearData() {
      if (this.myChart) this.myChart.dispose();
      this.transformType = true; // 展示类型 图表/表格
      this.spinShow = true; // 图表加载状态显示/隐藏
      this.lodingInfo = this.$t('common.loading'); // 加载文字
      this.noData = true; // 表格加载状态显示/隐藏
      this.initChartInfo = {
        legendName: [],
        xaxisData: [],
        yaxis: [],
        series: [],
      };
      this.initTableData = {
        columns: [],
        data: [],
      };
    },
  },
};
</script>
